<template>
    <div class="map-wrapper">
      <div class="map-section map-interactive">
        <l-map class="map-section__leaflet" :center="centerTo" :min-zoom="5" :zoom="zoomTo">
        <l-tile-layer
        :url="url" />

        <div v-if="showLayer=='show_departamentos'">
          <l-geo-json :geojson="departamentos.content" ref="base_map" :options="departamentos.options">
            <l-tooltip></l-tooltip>
          </l-geo-json>
        </div>

        <div v-if="showLayer=='show_distritos'">
          <l-geo-json
            :geojson="dep.content"
            :key="dep.id"
            :ref="dep.id"
            :options="dep.options"
            v-for="dep in departamentos_distritos"
          ></l-geo-json>
        </div>

        <div class="container-legend">
          <div>RESUMEN</div>
          <ul class="legend d-flex">
            <li>
              <label>0</label>
              <span style="background-color:#ffffff;"></span>
            </li>
            <li>
              <label> +5 </label>
              <span style="background-color:#ffffb2;"></span>
            </li>
            <li>
              <label> +10 </label>
              <span style="background-color:#fed976;"></span>
            </li>
            <li>
              <label> +20 </label>
              <span style="background-color:#feb24c;"></span>
            </li>
            <li>
              <label> +50 </label>
              <span style="background-color:#fd8d3c;"></span>
            </li>
            <li>
              <label> +100 </label>
              <span style="background-color:#fc4e2a;"></span>
            </li>
            <li>
              <label> +200 </label>
              <span style="background-color:#e31a1c;"></span>
            </li>
            <li>
              <label> +600 </label>
              <span style="background-color:#b10026;"></span>
            </li>
          </ul>
        </div>

        <div v-if="circleShow" >
          <l-layer-group :ref="`features_${dep.id}`" :key="`cg_${dep.id}`" v-for="dep in departamentos_distritos">
            <l-circle-marker :key="n" v-for="(dis, n) in dep.distritos"
              :lat-lng="dis.center"
              :radius="dis.radius"
              :color="dis.color"
              fillColor="#369962"
              class="circle-district"
              @click="loadZoom(dis)"
            >
            </l-circle-marker>
          </l-layer-group>
        </div>

      </l-map>
      </div>
      <div class="pmf-list" :class="{'open': openpmf}">
        <ul>
          <li class="close-map">
            <a class="text-center d-block" href="#" @click="openpmf=false">
              <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" class="bi bi-x" viewBox="0 0 16 16">
                <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
              </svg>
            </a>
            <div v-if="!selected.dep">{{$t('mapa_planes_region')}} {{ selected.name }}</div>              
            <div v-if="selected.dep">{{$t('mapa_planes_distrito')}} {{ selected.name }}</div>              
            <div v-if="selected.dep">{{$t('mapa_planes_provincia')}} {{ selected.prov }}</div>              
            <div v-if="selected.dep">{{$t('mapa_planes_region_dos')}} {{ selected.dep }}</div>              
          </li>
          <li :key="d.id" v-for="d in data_pmf_mapa">
            <div><b>{{ d.titular_actual }}</b></div>
            <div v-if="d.mues_supervisado_pmf!='ND'">
              <div class="supervisado">{{$t('mapa_planes_arboles_sup')}} {{ d.mues_supervisado_pmf }}</div>
              <div class="inexistentes">{{$t('mapa_planes_arboles_inexis')}} {{ ((d.individuos_inexistentes / d.mues_supervisado_pmf) * 100).toFixed(0) }}% ({{d.individuos_inexistentes}} {{$t('mapa_planes_arboles')}})</div>
            </div>
            <div v-if="d.mues_supervisado_pmf=='ND'">
              <div class="inexistentes">{{$t('mapa_planes_datos_inex')}}</div>
            </div>
            <div class="mt-1">
              <router-link class="btn" :to="`/planes/${d.resolucion_poa_id}`">{{$t('mapa_planes_ver_pmf')}}</router-link>
            </div>
          </li>
        </ul>
      </div>
    </div>
</template>
<script>

import { LMap, LTileLayer, LGeoJson, LCircleMarker, LLayerGroup, LTooltip } from 'vue2-leaflet';
import 'leaflet/dist/leaflet.css';

export default {
  name: 'MapaPlanes',
  components: {
    LMap,
    LTileLayer,
    LGeoJson,
    LCircleMarker,
    LLayerGroup,
    LTooltip
 },
 props: {
  circleShow: {
    type: Boolean
  },
  showLayer: {
    type: String
  },
  departamentos: {
    type: Object
  },
  departamentos_distritos: {
    type: Array
  },
  datapmf: {
    type: Array
  },
  selected: {
    type: Object
  },
 },
 watch: {
   datapmf(v) {
    if(v && v.length > 0) {
      this.data_pmf_mapa = v
      this.openpmf = true
    }
   },
   showLayer() {
      this.openpmf = false
   }
 },
 methods: {
  closePanel() {
    this.distritoActive = ''
    this.zoomTo = 5
    this.centerTo = [-10.040651, -75.840726]
    this.datapmf = []
  },
  loadZoom(dis) {
    this.openpmf = true
    //this.distritoActive = `${dis.distrito} / ${dis.provincia} / ${dis.departamento}`
    this.zoomTo = 9
    this.centerTo = [dis.latitud, dis.longitud]
    this.data_pmf_mapa = dis.planes
  }
 },
 mounted() {
  this.data_pmf_mapa = this.departamentos_distritos
 },
 data() {
   return {
    data_pmf_mapa: [],
    openpmf: false,
    zoomTo: 5,
    centerTo: [-10.040651, -75.840726],
    url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'
   }
 }
};
</script>

<style lang="scss">
        
  .map-section {
    position: relative;
    min-height: 80vh;
    margin-bottom: 45px;
    background: white;

    .container-legend {
      position: absolute;
      top: 30px;
      right: 10px;
      z-index: 99999;
      padding: 10px;
      background: #6d757d;
      color: #fff;
      border-radius: 3px;

      @media only screen and (max-width: 720px) {
        top: auto;
        bottom: 0;
        left: 0;
        right: auto;
        padding: 5px;
      }

      ul {
        margin: 0;
        padding: 0;
      }

      li {
        list-style: none;
        margin: 0 5px;
      }

      label {
        margin: 0;
        display: block;
        color: #fff;
        font-size: 10px;
      }

      span {
        display: inline-block;
        width: 20px;
        height: 20px;
      }
    }
    

    @media only screen and (max-width: 720px) {
      min-height: 50vh;
    }

    &__leaflet {
      bottom:0;
      padding:0;
      position: absolute;
      right: 0;
      z-index: 50;
      &--fixed {
        position: fixed;
        top: 0;
      }
      &--absolute {
        position: absolute;
        bottom: 0;
      }
      &__source {
        position:  absolute;
        bottom:0;
        left:0;
        font-size: 11px;
        padding: 0 5px;
        max-width: calc(100% - 60px);
      }
    }
    & &__leaflet.vue2leaflet-map.leaflet-container {
      background: inherit;
      .leaflet-pane.leaflet-overlay-pane > svg > g > path.leaflet-interactive {
        transition: stroke 2s, fill 2s;
      }
    }
  }
</style>